import { isEmpty } from "@utils/lodash";

import { allFuelTypes } from "@utils/metaData";
import {
  makeModelModalClosed,
  fuelTypeModalClosed,
  variantModalClosed,
  findMakeModelModalOpened,
  selectFuelTypeModalLoaded,
  selectVariantLoaded,
  popularCarsSelected,
  makeModelSelected,
  mmvScreenContinueClicked,
  variantSelected,
  variantSkipped,
  fuelTypeSkipped,
  fuelTypeClicked
} from "@analytics/car/actions/landing";

import {
  makeModelModalClosed as newCarMakeModelModalClosed,
  fuelTypeModalClosed as newCarFuelTypeModalClosed,
  variantModalClosed as newCarVariantModalClosed,
  findMakeModelModalOpened as newCarFindMakeModelModalOpened,
  selectFuelTypeModalLoaded as newCarSelectFuelTypeModalLoaded,
  selectVariantLoaded as newCarSelectVariantLoaded,
  popularCarsSelected as newCarPopularCarsSelected,
  makeModelSelected as newCarMakeModelSelected,
  mmvScreenContinueClicked as newCarMmvScreenContinueClicked,
  variantSelected as newCarVariantSelected,
  variantSkipped as newCarVariantSkipped,
  fuelTypeSkipped as newCarFuelTypeSkipped,
  fuelTypeClicked as newCarfuelTypeClicked
} from "@analytics/newCar/actions/landing";

import {
  SelectedValueInterface,
  VehicleFilterArgs
} from "@components/car/journey/types.d";
import {
  carVariantListLoaded,
  carVariantSelected,
  fuelTypeListLoaded,
  fuelTypeListSelected,
  makeModelListLoaded,
  popularMakeModelSelected,
  typedMakeModelSelected
} from "segments/eventActions/car/prequoteModule";

const getNewCarFlag = () => {
  return window.isNewCar;
};
// calling dropdown/modal as modal for sake of simplicity between Desktop & mWeb designs
export const getFuelType = ({ allFuelTypes, chosenCar }) => {
  const uniqueFuelType: string[] = [];
  if (!isEmpty(chosenCar.variants)) {
    chosenCar.variants.forEach(item => {
      if (uniqueFuelType.indexOf(item.fuel_type) === -1) {
        // eslint-disable-line
        uniqueFuelType.push(item.fuel_type); // eslint-disable-line
      }
    });
  }

  return uniqueFuelType.map(item => {
    return {
      name: (allFuelTypes as any)[item],
      key: item
    };
  });
};

export const getVariantType = ({ allFuelTypes, chosenCar, chosenModel }) => {
  return !isEmpty(chosenCar.variants) && !isEmpty(chosenModel)
    ? chosenCar.variants.filter(
        item => (allFuelTypes as any)[item.fuel_type] === chosenModel
      )
    : [];
};

// triggers relevant r2d2 on Modal close
export const fireCloseModalR2d2 = ({ modalType, dispatch }) => {
  const isNewCar = getNewCarFlag();
  if (modalType === "make") {
    dispatch(
      isNewCar ? newCarMakeModelModalClosed({}) : makeModelModalClosed({})
    );
  } else if (modalType === "model") {
    dispatch(
      isNewCar ? newCarFuelTypeModalClosed({}) : fuelTypeModalClosed({})
    );
  } else if (modalType === "variant") {
    dispatch(isNewCar ? newCarVariantModalClosed({}) : variantModalClosed({}));
  }
};

// triggers relevant r2d2 on Modal close
export const fireOpenModalR2d2 = ({ modalType, dispatch }) => {
  const isNewCar = getNewCarFlag();
  if (modalType === "make") {
    if (dispatch) {
      dispatch(makeModelListLoaded({}));
      dispatch(
        isNewCar
          ? newCarFindMakeModelModalOpened({})
          : findMakeModelModalOpened({})
      );
    }
  } else if (modalType === "model") {
    if (dispatch) {
      dispatch(fuelTypeListLoaded({}));
      dispatch(
        isNewCar
          ? newCarSelectFuelTypeModalLoaded({})
          : selectFuelTypeModalLoaded({})
      );
    }
  } else if (modalType === "variant") {
    if (dispatch) {
      dispatch(carVariantListLoaded({}));
      dispatch(
        isNewCar ? newCarSelectVariantLoaded({}) : selectVariantLoaded({})
      );
    }
  }
};

export const fireMakeSelectionR2d2 = ({
  selectedVehicle,
  searchText,
  popularVehicles,
  dispatch
}) => {
  const isPopularVehicel = popularVehicles?.find(
    vehicle => vehicle.id === selectedVehicle?.id
  );
  const isNewCar = getNewCarFlag();
  const isTypo = !(
    selectedVehicle &&
    selectedVehicle.name &&
    selectedVehicle.name.toLowerCase().startsWith(searchText.toLowerCase())
  );
  const customAttributes = {
    vehicle_make: selectedVehicle?.name.split(" ")[0],
    vehicle_model: selectedVehicle?.name
      .split(" ")
      .slice(1)
      .join(" "),
    vehicle_variant: ""
  };
  if (isPopularVehicel) {
    dispatch(popularMakeModelSelected(customAttributes));
    const edata = {
      vehicle_make_model: selectedVehicle.name,
      search_text: !(searchText === "") ? searchText : undefined,
      typo: !(searchText === "") ? isTypo : undefined
    };
    dispatch(
      isNewCar
        ? newCarPopularCarsSelected({ edata })
        : popularCarsSelected({ edata })
    );
  } else {
    const edata = {
      vehicle_make_model: selectedVehicle.name,
      search_text: !(searchText === "") ? searchText : undefined,
      typo: !(searchText === "") ? isTypo : undefined
    };
    dispatch(typedMakeModelSelected({ customAttributes }));
    dispatch(
      isNewCar
        ? newCarMakeModelSelected({ edata })
        : makeModelSelected({
            edata
          })
    );
  }
};

export const handleModal = ({
  type,
  setModalType,
  chosenCar,
  chosenModel,
  handleToast,
  ...rest
}) => {
  if (
    type === "make" ||
    (type === "model" && chosenCar.name !== "") ||
    (type === "variant" && chosenCar.name !== "" && chosenModel !== "")
  ) {
    setModalType(type);
    fireOpenModalR2d2({ modalType: type, dispatch: rest?.dispatch });
  } else {
    if (chosenCar.name === "") handleToast("choose car");

    if (chosenCar.name !== "" && chosenModel === "")
      handleToast("choose fuel type");
  }
};

export const handleNextModal = async ({ type, setModalType, dispatch }) => {
  const isNewCar = getNewCarFlag();
  await setModalType("");
  let nextModal = "";
  if (type === "make") nextModal = "model";
  if (type === "model") nextModal = "variant";
  await setModalType(nextModal);

  if (nextModal === "model") {
    dispatch(fuelTypeListLoaded({}));
    dispatch(
      isNewCar
        ? newCarSelectFuelTypeModalLoaded({})
        : selectFuelTypeModalLoaded({})
    );
  } else if (nextModal === "variant") {
    dispatch(carVariantListLoaded({}));
    dispatch(
      isNewCar ? newCarSelectVariantLoaded({}) : selectVariantLoaded({})
    );
  }
};

export const handleMmvDetails = ({
  chosenCar,
  chosenModel,
  chosenVariant,
  handleClick,
  toggleError,
  dispatch
}) => {
  const make = chosenCar.name;
  const model = chosenModel;
  const variant = chosenVariant.name;
  const isNewCar = getNewCarFlag();
  if (isEmpty(make) || isEmpty(model) || isEmpty(variant)) toggleError(true);
  else {
    handleClick({
      make: chosenCar,
      model: chosenModel,
      variant: chosenVariant
    });
    const edata = {
      vehicle_variant: chosenVariant.name,
      vehicle_make_model: chosenCar.name,
      fuel_type: chosenVariant.fuel_type
    };
    dispatch(
      isNewCar
        ? newCarMmvScreenContinueClicked({})
        : mmvScreenContinueClicked({
            edata
          })
    );
  }
};

export const handleVehicleDetails = ({
  chosenCar,
  chosenModel,
  chosenVariant,
  handleClick,
  toggleError,
  dispatch,
  registrationYear,
  registrationMonth
  // isCommercial,
  // externalCNG
}) => {
  const make = chosenCar.name;
  const model = chosenModel;
  const variant = chosenVariant.name;
  if (
    isEmpty(make) ||
    isEmpty(model) ||
    isEmpty(variant) ||
    isEmpty(registrationYear) ||
    isEmpty(registrationMonth)
  ) {
    toggleError(true);
  } else {
    handleClick({
      make: chosenCar,
      model: chosenModel,
      variant: chosenVariant,
      registrationYear,
      registrationMonth
      // externalCNG,
      // isCommercial
    });
    dispatch(
      mmvScreenContinueClicked({
        edata: {
          vehicle_variant: chosenVariant.name,
          vehicle_make_model: chosenCar.name,
          fuel_type: chosenVariant.fuel_type
        }
      })
    );
  }
};

export const handleSingleVariant = ({
  variantData,
  model,
  setChosenModel,
  setChosenVariant,
  setModalType,
  dispatch
}) => {
  const isNewCar = getNewCarFlag();
  setChosenModel(model.name);
  setChosenVariant(variantData[0]);

  setModalType("");
  const edata = {
    vehicle_variant: variantData[0]
  };
  dispatch(
    carVariantSelected({
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: variantData[0]?.name
    })
  );
  dispatch(
    isNewCar
      ? newCarVariantSelected({ edata })
      : variantSelected({
          edata
        })
  );
};

export const handleSingleFuel = ({
  fuelData,
  car,
  chosenCar,
  chosenModel,
  setChosenModel,
  setChosenVariant,
  setModalType,
  chosenVariantInitState,
  allFuelTypes,
  dispatch
}) => {
  const isNewCar = getNewCarFlag();
  setChosenModel(fuelData[0].name);
  setChosenVariant(chosenVariantInitState);
  const variants = getVariantType({
    allFuelTypes,
    chosenCar: car,
    chosenModel: fuelData[0].name
  });
  if (variants.length === 1) {
    handleSingleVariant({
      variantData: variants,
      model: fuelData[0],
      setChosenModel,
      setChosenVariant,
      setModalType,
      dispatch
    });
    const edata = {
      fuel_type: chosenModel,
      vehicle_make_model: chosenCar.name,
      vehicle_variant: variants[0].name
    };
    dispatch(fuelTypeListSelected({ fuel_type: chosenModel }));
    dispatch(
      isNewCar
        ? newCarVariantSkipped({ edata })
        : variantSkipped({
            edata
          })
    );

    handleNextModal({ type: "variant", setModalType, dispatch });
    return;
  }
  handleNextModal({ type: "model", setModalType, dispatch });
};

// Heart function of MMV <3
export const handleMmvClickOptions = ({
  value,
  type,
  allFuelTypes,
  modalType,
  chosenCar,
  chosenModel,
  setChosenCar,
  setChosenModel,
  chosenVariantInitState,
  setChosenVariant,
  setModalType,
  searchText,
  popularVehicles,
  dispatch
}: any) => {
  const isNewCar = getNewCarFlag();
  const fuelData = getFuelType({ allFuelTypes, chosenCar: value });
  const variantData = getVariantType({
    allFuelTypes,
    chosenCar,
    chosenModel: value.name
  });

  if (type === "make" && chosenCar.name !== value.name) {
    setChosenCar(value);
    setChosenModel("");
    setChosenVariant(chosenVariantInitState);
    fireMakeSelectionR2d2({
      selectedVehicle: value,
      searchText,
      popularVehicles,
      dispatch
    });
    // if car has just one fuel type
    if (fuelData.length === 1) {
      handleSingleFuel({
        fuelData,
        car: value,
        chosenCar,
        chosenModel,
        setChosenModel,
        setChosenVariant,
        setModalType,
        chosenVariantInitState,
        allFuelTypes,
        dispatch
      });
      const edata = {
        fuel_type: fuelData[0].name,
        vehicle_make_model: chosenCar.name
      };
      dispatch(
        isNewCar
          ? newCarFuelTypeSkipped({ edata })
          : fuelTypeSkipped({
              edata
            })
      );
      return;
    }
  }
  // when user selects the same car again
  else if (fuelData.length === 1) {
    handleSingleFuel({
      fuelData,
      car: value,
      chosenCar,
      chosenModel,
      setChosenModel,
      setChosenVariant,
      setModalType,
      chosenVariantInitState,
      allFuelTypes,
      dispatch
    });
    const edata = {
      fuel_type: fuelData[0].name,
      vehicle_make_model: chosenCar.name
    };
    dispatch(
      isNewCar ? newCarFuelTypeSkipped({ edata }) : fuelTypeSkipped({ edata })
    );
    return;
  } else if (type === "model" && chosenModel !== value) {
    setChosenVariant(chosenVariantInitState);
    setChosenModel(value.name);
    const edata = {
      fuel_type: value.name,
      vehicle_make_model: chosenCar.name
    };
    dispatch(fuelTypeListSelected({ fuel_type: value.name }));
    dispatch(
      isNewCar ? newCarfuelTypeClicked({ edata }) : fuelTypeClicked({ edata })
    );
    if (variantData.length === 1) {
      handleSingleVariant({
        variantData,
        model: value,
        setChosenModel,
        setChosenVariant,
        setModalType,
        dispatch
      });
      const edata = {
        fuel_type: chosenModel,
        vehicle_make_model: chosenCar.name,
        vehicle_variant: variantData.name
      };
      dispatch(
        isNewCar ? newCarVariantSkipped({ edata }) : variantSkipped({ edata })
      );

      return;
    }
  } else if (type === "variant") {
    const isTypo = !value.name
      .toLowerCase()
      .startsWith(searchText.toLowerCase());
    setChosenVariant(value);
    const edata = {
      fuel_type: value.name,
      vehicle_make_model: chosenCar.name,
      vehicle_variant: value.name,
      search_text: !(searchText === "") ? searchText : undefined,
      typo: !(searchText === "") ? isTypo : undefined
    };
    const [make, model] = chosenCar?.name.split(" ");
    dispatch(
      carVariantSelected({
        vehicle_make: make,
        vehicle_model: model,
        vehicle_variant: value.name
      })
    );
    dispatch(
      isNewCar ? newCarVariantSelected({ edata }) : variantSelected({ edata })
    );
  }
  handleNextModal({ type: modalType, setModalType, dispatch });
};

/* Returns a string like Variant (1111cc) - FuelType */
export function getVariantText(
  variant: string | null,
  cc: number | null,
  fuelType: string | null
): string {
  let variantText = "";
  const ccType = fuelType === "Electric" ? "kW" : "cc";
  let ccValue;
  if (cc) {
    if (fuelType === "Electric") {
      ccValue = (cc / 1000).toFixed(1);
    } else {
      ccValue = cc;
    }
  }
  variantText += variant ?? "";
  variantText += variantText.length && (cc ? ` (${ccValue}${ccType})` : "");
  variantText += variantText.length && (fuelType ? ` - ${fuelType}` : "");

  return variantText;
}

export function getVehicleData({
  vehicles,
  make,
  model,
  variantId
}: VehicleFilterArgs): SelectedValueInterface | null {
  let vehicleData: any | null = null;
  let variant: any | null = null;

  if (make && model) {
    const searchString = `${make} ${model}`.toLowerCase();

    vehicleData = vehicles.find(vehicle => {
      return vehicle.name.toLowerCase() === searchString;
    });
    variant = vehicleData?.variants.find(variant => variant.id === variantId);
  } else if (variantId) {
    vehicleData = vehicles.find(vehicle => {
      variant = vehicle.variants.find(variant => variant.id === variantId);
      return Boolean(variant);
    });
  }

  return {
    make: vehicleData,
    model: variant?.fuel_type ? allFuelTypes[variant.fuel_type] : "",
    variant
  };
}

export function getVehicleById(
  vehicles: any[],
  vehicleId: string
): any | null {
  if (!vehicles?.length || !vehicleId) return null;
  
  return vehicles.find(vehicle => vehicle.id === vehicleId) || null;
}

export default {};
